import ApolloClient from 'apollo-client'
import { Calculation } from 'final-form-calculate'
import { AgendadoAtendimentoFormDocument, EquipeAtendimentoDocument } from 'graphql/hooks.generated'
import { isEqual } from 'lodash'

import { meta, NovoAtendimentoFormModel } from './model'

const equipeCalculator = (apollo: ApolloClient<object>, isCEO?: boolean) => [
  {
    field: meta.lotacao.absolutePath(),
    updates: {
      [meta.equipe.absolutePath()]: (
        lotacao: NovoAtendimentoFormModel['lotacao'],
        allValues: NovoAtendimentoFormModel
      ) => {
        if (lotacao?.equipe?.id && !isCEO) {
          return apollo
            .query({
              query: EquipeAtendimentoDocument,
              variables: { id: lotacao.equipe.id },
            })
            .then((res) => res.data.equipe)
        } else {
          if (lotacao?.id) return null
        }
        return allValues.equipe
      },
    },
  },
]

const agendadoChange = (apollo: ApolloClient<object>) => [
  {
    field: meta.agendados.absolutePath(),
    updates: async (agendados: NovoAtendimentoFormModel['agendados'], field, allValues: NovoAtendimentoFormModel) => {
      let data: NovoAtendimentoFormModel = { ...allValues }

      data.agendados = agendados?.length >= 1 ? [agendados[agendados.length - 1]] : undefined

      if (data.agendados?.length === 1) {
        const lotacao = await apollo
          .query({
            query: AgendadoAtendimentoFormDocument,
            variables: { id: agendados[0] },
          })
          .then((res) => {
            return res.data.agendado.lotacaoAgendada
          })
        data = { ...data, ...{ lotacao, equipe: lotacao.equipe } }
      } else {
        data = { ...data, ...{ lotacao: undefined, equipe: undefined } }
      }
      return data
    },
    isEqual: (a, b) => isEqual(a, b),
  },
]

export const createNovoAtendimentoCalculations = (apollo: ApolloClient<object>, isCEO?: boolean): Calculation[] => [
  ...agendadoChange(apollo),
  ...equipeCalculator(apollo, isCEO),
]
